import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const LISTING_DESCRIPTION_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    ['link'],
    ['clean'],
  ],
};

const LISTING_DESCRIPTION_FORMATS = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'indent',
  'link',
];

export interface ListingDescriptionEditorProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  readOnly?: boolean;
  className?: string;
}

const ListingDescriptionEditor: React.FC<ListingDescriptionEditorProps> = ({
  value,
  onChange,
  placeholder = 'Detailed description — formatting is saved and shown to buyers.',
  readOnly,
  className,
}) => {
  const modules = useMemo(() => LISTING_DESCRIPTION_MODULES, []);

  return (
    <div
      className={[
        'listing-description-editor rounded-lg border border-slate-200 bg-white shadow-sm',
        '[&_.ql-toolbar]:border-slate-200 [&_.ql-toolbar]:rounded-t-lg [&_.ql-toolbar]:border-b [&_.ql-toolbar]:bg-slate-50/80',
        '[&_.ql-container]:rounded-b-lg [&_.ql-container]:border-0 [&_.ql-container]:font-sans',
        '[&_.ql-editor]:min-h-[200px] [&_.ql-editor]:max-h-[min(420px,50vh)] [&_.ql-editor]:overflow-y-auto [&_.ql-editor]:px-3 [&_.ql-editor]:py-2.5 [&_.ql-editor]:text-[15px] [&_.ql-editor]:leading-relaxed [&_.ql-editor]:text-slate-800',
        '[&_.ql-editor.ql-blank::before]:left-3 [&_.ql-editor.ql-blank::before]:text-slate-400',
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={(html) => onChange?.(html)}
        modules={modules}
        formats={LISTING_DESCRIPTION_FORMATS}
        placeholder={placeholder}
        readOnly={readOnly}
      />
    </div>
  );
};

export default ListingDescriptionEditor;
